export default __webpack_public_path__ + "static/media/prize.8c0597f6.svg";